import { GetSessionV2Response } from "@endavaaccorplus/payments-common/schemas";

export const getResidenceAttribute = (session: GetSessionV2Response) => {
  return session.customer?.country ?? "Unknown";
};
